import { Skeleton } from "@mui/material";

import { useAppSelector } from "../../store/store";
import { FinanceGrid } from "./PriceHistory/FinanceGrid/FinanceGrid";
import { FinanceGridHeader } from "./PriceHistory/FinanceGrid/FinanceGridHeader";
import { useFinanceGridChannels } from "./PriceHistory/FinanceGrid/useFinanceGridChannels";

const SKELETON_ROW_COUNT = 4;
const SKELETON_COLUMN_COUNT = 6;

const TitlePriceTableSkeleton = () => (
    <div className="overflow-x-auto">
        <table className="w-full text-left table-fixed">
            <colgroup>
                <col className="w-3/12" />
                <col className="w-1/12" />
                <col className="w-1/12" />
                <col className="w-3/12" />
                <col className="w-2/12" />
                <col className="w-2/12" />
            </colgroup>
            <FinanceGridHeader />
            <tbody>
                {Array.from({ length: SKELETON_ROW_COUNT }, (_, rowIndex) => (
                    <tr key={rowIndex} className="border-b border-border-color last:border-b-0">
                        {Array.from({ length: SKELETON_COLUMN_COUNT }, (_, columnIndex) => (
                            <td key={columnIndex} className="py-2 px-3">
                                <Skeleton variant="text" />
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export const TitlePriceTable = ({ isLoading = false }: { isLoading?: boolean }) => {
    const { title: currentTitle } = useAppSelector((state) => state.titles);
    const channels = useFinanceGridChannels();

    if (isLoading) {
        return <TitlePriceTableSkeleton />;
    }

    if (!currentTitle) {
        return null;
    }

    return <FinanceGrid channels={channels} />;
};
